import { combineReducers } from "redux";

import account from "./account";
import allocationHistory from "./allocationHistory";
import allocationSummary from "./allocationSummary";
import analyticsTracker from "./analyticsTracker";
import authentication from "./authentication";
import beneficiaries from "./beneficiaries";
import cases from "./cases";
import constellation from "./constellation";
import counter from "./counter";
import country from "./country";
import coverageDetails from "./coverageDetails";
import deviceFingerprint from "./device-fingerprint";
import disclosures from "./disclosures";
import documents from "./documents";
import dynamicForm from "./dynamicForm";
import dynamicFormModal from "./dynamicFormModal";
import estimate from "./estimate";
import featureFlags from "./featureFlags";
import formFlow from "./formFlow";
import header from "./header";
import insuranceApplication from "./insuranceApplication";
import insuranceMembership from "./insuranceMembership";
import invoice from "./invoice";
import journey from "./journey";
import modal from "./modal";
import notifications from "./notifications";
import payment from "./payment";
import pendingPolicy from "./pendingPolicy";
import policy from "./policy";
import policyRiders from "./policyRiders";
import productOffering from "./productOffering";
import profile from "./profile";
import quote from "./quote";
import reinstateablePolicies from "./reinstateablePolicies";
import request from "./request";
import states from "./states";
import translations from "./translations";
import trivia from "./trivia";
import user from "./user";
import wyshAllocations from "./wyshAllocations";
import wyshCategories from "./wyshCategories";
import wyshes from "./wyshes";
import wyshesFlow from "./wyshesFlow";

const createRootReducer = () =>
  combineReducers({
    account,
    allocationHistory,
    allocationSummary,
    authentication,
    analyticsTracker,
    beneficiaries,
    cases,
    constellation,
    counter,
    country,
    coverageDetails,
    deviceFingerprint,
    disclosures,
    documents,
    dynamicForm,
    dynamicFormModal,
    estimate,
    featureFlags,
    formFlow,
    header,
    insuranceApplication,
    insuranceMembership,
    invoice,
    journey,
    modal,
    notifications,
    payment,
    pendingPolicy,
    policy,
    policyRiders,
    productOffering,
    profile,
    quote,
    reinstateablePolicies,
    request,
    states,
    translations,
    trivia,
    user,
    wyshAllocations,
    wyshCategories,
    wyshes,
    wyshesFlow,
  });

export default createRootReducer;
